import styled from 'styled-components';
import React from 'react';
import ArticleCard from '../ArticleCard';
import { Article } from './types';

interface ArticleCardTemplateRichProps extends Article {
  largeTitle?: boolean;
}

export default function ArticleCardTemplateRich({
  title,
  author,
  createdAt,
  tags,
  summary,
  hasVideo,
  largeTitle,
}: ArticleCardTemplateRichProps) {
  return (
    <ArticleCardTemplateRichCss>
      <ArticleCardTemplateRichContentCss>
        <ArticleCard.Title large={Boolean(largeTitle)}>
          {title}
        </ArticleCard.Title>
        <ArticleCardTemplateRichSummaryCss>
          {summary}
        </ArticleCardTemplateRichSummaryCss>
        <ArticleCard.Meta author={author} createdAt={createdAt} />
      </ArticleCardTemplateRichContentCss>
      <ArticleCardTemplateRichFooterCss tags={tags} hasVideo={hasVideo} />
    </ArticleCardTemplateRichCss>
  );
}

const ArticleCardTemplateRichCss = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  padding: ${p => `0 ${p.theme.sizes.spacing5}`};
  border-radius: ${({
      theme: {
        sizes: { spacing1 },
      },
    }) => `0 ${spacing1} ${spacing1} 0 `}
    & > span {
    padding: ${p => p.theme.sizes.spacing5};
  }
`;

const ArticleCardTemplateRichSummaryCss = styled(ArticleCard.Summary)`
  display: -webkit-box;
  -webkit-line-clamp: 4;
  max-height: 50%;
  -webkit-box-orient: vertical;
`;

const ArticleCardTemplateRichContentCss = styled.div`
  max-height: 80%;
  max-width: 100%;
  padding: ${p => p.theme.sizes.spacing6} 0;
  overflow: hidden;
`;

const ArticleCardTemplateRichFooterCss = styled(ArticleCard.Footer)`
  position: absolute;
  bottom: ${p => p.theme.sizes.spacing1};
  width: calc(100% - ${p => p.theme.sizes.spacing6});
  left: ${p => p.theme.sizes.spacing5};
`;
